import React, { createContext, ReactNode, useState } from 'react'

interface InnerRouterContextProps {
  currentPath: string
  payload?: any
  goToInnerPage: (pagePath: string, payload?: any, currentState?: any) => void
  goBack: () => void
  previousState?: any
}

const InnerRouterContext = createContext<InnerRouterContextProps | undefined>(
  undefined
)

interface InnerRouterProviderProps {
  currentPath: string
  children: ReactNode
}

export const InnerRouterProvider: React.FC<InnerRouterProviderProps> = ({
  children,
  currentPath: currentPathProp,
}) => {
  const [currentPath, setCurrentPath] = useState<string>(currentPathProp)
  const [payload, setPayload] = useState<any>(undefined)
  const [previousState, setPreviousState] = useState<any>(undefined)

  const historyRef = React.useRef<{ path: string; currentState?: any }[]>([])

  React.useEffect(() => {
    historyRef.current.push({ path: currentPathProp })
  }, [currentPathProp])

  const contextValue = React.useMemo(
    () => ({
      currentPath: currentPath,
      payload,
      previousState,
      goToInnerPage: (pagePath: string, payload?: any, currentState?: any) => {
        setCurrentPath(pagePath)
        setPayload(payload)
        setPreviousState(undefined)

        historyRef.current[historyRef.current.length - 1].currentState =
          currentState

        historyRef.current.push({
          path: pagePath,
        })
        console.log('historyRef.current', historyRef.current, currentState)
      },
      goBack: () => {
        if (historyRef.current.length === 1) {
          return
        }
        historyRef.current.pop()
        console.log('historyRef.current', historyRef.current)
        setCurrentPath(historyRef.current[historyRef.current.length - 1].path)
        setPayload(undefined)
        setPreviousState(
          historyRef.current[historyRef.current.length - 1].currentState
        )
      },
    }),
    [currentPath, payload, previousState]
  )

  return (
    <InnerRouterContext.Provider value={contextValue}>
      {children}
    </InnerRouterContext.Provider>
  )
}

export const useInnerRouter = () => {
  const context = React.useContext(InnerRouterContext)
  if (!context) {
    throw new Error('useInnerRouter must be used within an InnerRouterProvider')
  }

  return context
}
